import React, { Suspense, useCallback, useState } from 'react';
import { Button, DataTable, Flexbox, Input, Panel, Skeleton } from '@sonika-se/ui-kit/components';
import { graphql, usePreloadedQuery, useQueryLoader } from 'react-relay/hooks';
import { formatDate, toDate } from '@sonika-se/ui-kit/utils/time';
const query = graphql `
  query PublicHolidaysPanelQuery($filter: Admin_GetHolidaysFilterInput) {
    admin_getHolidays(filter: $filter) {
      date
      id
      isRedDay
      title
    }
  }
`;
export const PublicHolidaysPanel = () => {
    const defaultYear = new Date().getFullYear();
    const [selectedYear, setSelectedYear] = useState(defaultYear);
    const [queryRef, loadQuery] = useQueryLoader(query);
    const refresh = useCallback(() => {
        loadQuery({ filter: { year: selectedYear } }, { fetchPolicy: 'network-only' });
    }, [selectedYear, loadQuery]);
    return (<Panel title="Helgdagar" actions={<>
          <Flexbox gap="small" justify="end">
            <Input type="number" value={selectedYear} onChange={(e) => {
                setSelectedYear(Number(e));
            }}/>
            <Button 
        //icon={faSync}
        size="small" appearance="filled" onClick={() => {
                // setDisplayDeleteConfirm(true)
                refresh();
            }}>
              Sök
            </Button>
          </Flexbox>
        </>}>
      <Suspense fallback={<Skeleton height="100%" type="page"/>}>
        {queryRef && <RenderTable queryRef={queryRef}/>}
      </Suspense>
      {!queryRef && <div>Välj år och sök</div>}
    </Panel>);
};
const RenderTable = ({ queryRef }) => {
    const data = usePreloadedQuery(query, queryRef);
    const holidays = data === null || data === void 0 ? void 0 : data.admin_getHolidays.map((x, index) => ({
        date: x.date,
        title: x.title,
        isRedDay: x.isRedDay,
    }));
    const hasHolidays = holidays && holidays.length > 0;
    return (<>
      <DataTable columns={{
            title: {
                text: 'Namn',
            },
            date: {
                render: (date) => formatDate(toDate(date), 'date'),
                text: 'Datum',
            },
            isRedDay: {
                render: (isRedDay) => (isRedDay ? 'Ja' : 'Nej'),
                text: 'Röd dag',
            },
        }} rows={holidays}/>
      {!hasHolidays && <div>Hittade inga helgdagar</div>}
    </>);
};
export default PublicHolidaysPanel;
